<!-- <div>
    <h1>{{ idleState }}</h1>
    <div *ngIf="lastPing">Last keep-alive ping: {{ lastPing | amTimeAgo }}</div>
  </div> -->
<router-outlet></router-outlet>
